import { Response } from '@/_metronic/helpers'
import axios, { AxiosResponse } from 'axios'
import { KpiModel } from './_models'

const BASE_URL = '/p2c/reports/kpi'

// eslint-disable-next-line
const formatParams = (params?: Record<string, any>): Record<string, any> => {
  if (!params) return {};

  const formatted = Object.fromEntries(
    Object.entries(params).map(([key, value]) => {
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');

        return [key, `${year}-${month}-${day}`];
      }
      return [key, value];
    })
  );

  return formatted;
};

interface IParams {
  from: Date;
  to: Date;
  timezone: string;
}

export const getKpi = async (params: IParams): Promise<KpiModel | undefined> => {
  return axios
    .get(BASE_URL, { params: formatParams(params) })
    .then((d: AxiosResponse<Response<KpiModel>>) => d.data)
    .then((d: Response<KpiModel>) => d.data)
}

